export const initialAbility = [
  {
    action: 'Auth',
    subject: 'all',
  }
]

export const _ = undefined
